import "./ProductSection.css";
import { motion } from "framer-motion";
import magang1  from '../../assets/magang1.png'
import ipoultry  from '../../assets/ipoultry.png'

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18
    }
  }
};

const revealUp = {
  hidden: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const imageReveal = {
  hidden: {
    scale: 1.15,
    opacity: 0
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 1.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const lineAnimation = {
  hidden: {
    width: 0
  },
  visible: {
    width: 90,
    transition: {
      delay: 0.3,
      duration: 1
    }
  }
};

export default function ProductSection() {
  return (
    <section id="products" className="product-section">

      <div className="background-glow glow-left"></div>
      <div className="background-glow glow-right"></div>

      <div className="container">

        <motion.div
          className="row align-items-center showcase-header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={container}
        >

          <div className="col-lg-6">

            <motion.span
              className="showcase-tag"
              variants={revealUp}
            >
              OUR PRODUCTS
            </motion.span>

            <motion.h2
              className="showcase-title"
              variants={revealUp}
            >
              Creating intelligent ecosystems through <span style={{'color' : "#08469a"}}>next-generation products.</span>
            </motion.h2>

          </div>

          <div className="col-lg-6">

            <motion.div
              className="showcase-content"
              variants={revealUp}
            >
              <p>
                Our products combine Artificial Intelligence, IoT connectivity,
                cloud infrastructure, and intelligent automation to solve
                real-world business challenges.
              </p>
            </motion.div>

          </div>

        </motion.div>

      </div>

      {/* PRODUCT 1 */}

      <motion.div
        className="product-block"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="container">

          <div className="row align-items-center gy-5">

            <div className="col-lg-6">

              <motion.div
                className="image-collage"
                variants={imageReveal}
              >

                <div className="image-overlay"></div>

                <motion.img
                  className="img-large"
                  style={{'height' : 'min-height !important'}}
                  src={ipoultry}
                  alt=""
                  animate={{
                    y: [0, -12, 0]
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 7
                  }}
                />

                {/* <motion.img
                  className="img-small top"
                  src="https://images.unsplash.com/photo-1601972599720-36938d4ecd31"
                  alt=""
                  animate={{
                    y: [0, -15, 0]
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 5
                  }}
                /> */}

                {/* <motion.img
                  className="img-small bottom"
                  src="https://images.unsplash.com/photo-1616401784845-180882ba9ba9"
                  alt=""
                  animate={{
                    y: [0, 15, 0]
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 6
                  }}
                /> */}

              </motion.div>

            </div>

            <div className="col-lg-6">

              <motion.div
                className="product-content"
                variants={revealUp}
                whileHover={{
                  y: -10,
                  scale: 1.02
                }}
              >

                <span className="product-tag">
                  OUR PRODUCT
                </span>

                <h2>
                  Poultry Management System
                </h2>

                <motion.div
                  className="accent-line"
                  variants={lineAnimation}
                />

                <p>
                  Our poultry management platform transforms commercial
                  farming through IoT sensors, AI predictive analytics,
                  and real-time automation.
                </p>

                <p>
                  Designed for large-scale EC sheds, the platform
                  continuously monitors environmental conditions.
                </p>

              </motion.div>

            </div>

          </div>

        </div>
      </motion.div>

      {/* PRODUCT 2 */}

<motion.div
  className="product-block dark"
  variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
>
  <div className="container">

    <div className="row align-items-center gy-5">

      {/* CONTENT */}

      <div className="col-lg-6 order-lg-1 order-2">

        <motion.div
          className="product-content"
          variants={revealUp}
          whileHover={{
            y: -10,
            scale: 1.02
          }}
        >

          <span className="product-tag">
            OUR PRODUCT
          </span>

          <h2>
            Ma Gang App
          </h2>

          <motion.div
            className="accent-line"
            variants={lineAnimation}
          />

          <p>
            Ma Gang is a Super App bringing together news,
            entertainment, sports, AI-powered assistance, and
            personalized digital experiences.
          </p>

          <p>
            Built for speed and scale, the platform delivers
            personalized content streams, intelligent recommendations,
            and real-time engagement.
          </p>

          <p>
            Users enjoy live cricket scores, breaking news alerts,
            movie reviews, AI interactions, and social engagement
            features within one ecosystem.
          </p>

        </motion.div>

      </div>

      {/* IMAGES */}

      <div className="col-lg-6 order-lg-2 order-1">

        <motion.div
          className="image-collage right"
          variants={imageReveal}
        >

          <div className="image-overlay"></div>

          <motion.img
            className="img-large"
            src={magang1}
            alt="Ma Gang App"
            animate={{
              y: [0, -12, 0]
            }}
            transition={{
              duration: 7,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />

          {/* <motion.img
            className="img-small top"
            src="https://images.unsplash.com/photo-1551650975-87deedd944c3"
            alt=""
            animate={{
              y: [0, -15, 0]
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          /> */}

          {/* <motion.img
            className="img-small bottom"
            src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c"
            alt=""
            animate={{
              y: [0, 15, 0]
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          /> */}

        </motion.div>

      </div>

    </div>

  </div>
</motion.div>

    </section>
  );
}